var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminDel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1022,
    height: 1022,
    viewBox: "0 0 1022 1022",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.001 425.834C675.628 425.834 809.085 368.638 809.085 298.084C809.085 227.53 675.628 170.334 511.001 170.334C346.374 170.334 212.918 227.53 212.918 298.084C212.918 368.638 346.374 425.834 511.001 425.834Z",
    stroke: "#0077FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.085 766.501L212.918 298.084L340.668 425.834H681.335L809.085 298.084L723.918 766.501L596.168 851.667H425.835L298.085 766.501Z",
    fill: "#0077FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M212.918 298.084L297.914 765.649C298.081 766.195 298.356 766.702 298.723 767.139C355.024 823.437 431.382 855.065 511.001 855.065C590.62 855.065 666.979 823.437 723.279 767.139C723.651 766.689 723.927 766.167 724.088 765.606L809.085 298.084",
    stroke: "#0077FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminDel);
export default __webpack_public_path__ + "static/media/adminDel.27d62cd1232ba15b399b8a28efc79ef9.svg";
export { ForwardRef as ReactComponent };